<div class="example-header">
    <button mat-icon-button (click)="previousClicked('month')">
        <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <span class="example-header-label">{{periodLabel}}</span>
    <button mat-icon-button (click)="nextClicked('month')">
        <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
</div>
